import { SPHUserRole } from './../../shared/model/sph-user.model';
import { SimpleOptionPopoverComponent } from './simple-option-popover.component';
import { AddLicensesComponent } from './../addLicensesComponent/add-licenses.component';
import { SPHLoggedInUser } from './../../shared/model/sph-logged-in-user.model';
import { LicenseManagerService } from './../../shared/licensemanager-service/licensemanager.service';
import { NavController, ToastController, Content, PopoverController } from 'ionic-angular';

import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SPHCompany, SPHLicense, SPHApplication } from '../../shared/shared';
import { LicenseDetailsComponent } from '../licenseDetailsComponent/license-details.component';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { EditLicenseComponent } from '../editLicenseComponent/edit-license.component';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { ResetLicenseComponent } from '../resetLicenseComponent/reset-license.component';

@Component({
    selector: 'lm-licenses',
    templateUrl: 'licenses.component.html'
})
export class LicensesComponent {
    @Output() public shouldReloadLicences: EventEmitter<any> = new EventEmitter<any>();
    @Input() public content: Content;
    @Input() public set company(company: SPHCompany) {
        this._company = company;
    }
    public get company(): SPHCompany {
        return this._company;
    }

    @Input() public set user(user: SPHLoggedInUser) {
        this._user = user;
        this.loadApplications();
    }
    public get user(): SPHLoggedInUser {
        return this._user;
    }

    private _company: SPHCompany;
    private _user: SPHLoggedInUser;
    private displayedLicenses: SPHLicense[] = [];

    private _licenses: SPHLicense[] = [];
    public get licenses(): SPHLicense[] {
        return this._licenses;
    }
    @Input() public set licenses(licenses: SPHLicense[]) {
        this._licenses = licenses;
        this.displayedLicenses = licenses.sort( (a, b) => {
            if (a.license_nr > b.license_nr) {
                return 1;
            } else if (a.license_nr < b.license_nr)  {
                return -1;
            } else {
                return 0;
            }
        } );
    }

    private selectedLicenses = new Set<SPHLicense>();

    private availableApplications: SPHApplication[];

    constructor(private navController: NavController, private licenseManagerService: LicenseManagerService, private modalController: ModalController, private toastController: ToastController, private popoverController: PopoverController) {}

    public didTapLicense(license: SPHLicense) {
        this.navController.push(LicenseDetailsComponent, { license, company: this.company, user: this.user, availableApplications: this.availableApplications });
    }

    public didTapAddLicense() {
        const modal = this.modalController.create(AddLicensesComponent, {company: this.company, user: this.user, availableApplications: this.availableApplications}, {enableBackdropDismiss: false});

        modal.onDidDismiss( ()  => {
            this.loadLicenses();
        });
        modal.present();
    }

    public didTapEditLicense(license: SPHLicense) {
        const modal = this.modalController.create(EditLicenseComponent, {license, user: this.user, availableApplications: this.availableApplications}, {enableBackdropDismiss: false});

        modal.onDidDismiss( () => {
            this.loadLicenses();
        });
        modal.present();
    }

    public didTapSelectAppLicenses() {
        if (this.selectedLicenses.size < this.displayedLicenses.length / 2) {
            this.displayedLicenses.forEach( (license) => {
                this.selectedLicenses.add(license);
            });
        } else {
           this.selectedLicenses.clear();
        }
    }

    public didTapSelectLicense(license: SPHLicense) {
        if (!this.selectedLicenses.has(license)) {
            this.selectedLicenses.add(license);
        } else {
            this.selectedLicenses.delete(license);
        }

        if (this.selectedLicenses.size === 1) {
            setTimeout( () => {if (this.content !== undefined) { this.content.scrollToBottom(100); }} );
        }

    }

    public didTapResetLicense(license: SPHLicense) {
      const modal = this.modalController.create(ResetLicenseComponent, { user: this.user, licenses: [license], applications : license.applications }, {enableBackdropDismiss: false});
      modal.present();
      modal.onDidDismiss(() => {
        this.loadLicenses();
      });
    }

    public didTapLockLicense(license: SPHLicense) {
        license.locked = !license.locked;
        this.licenseManagerService.patchLicense(license.id, license, this.user.jwt).subscribe( (nlicense) => {
            setTimeout( () => { this.loadLicenses(); }, 500);
            const toast = this.toastController.create({ message: 'Lizenz ' + (license.locked ? 'gesperrt!' : 'entsperrt!'), duration: 3000 });
            toast.present();
        }, (error) => {
            setTimeout( () => { this.loadLicenses(); }, 500);
            this.licenseManagerService.handleHttpError('Fehler beim' + (license.locked ? ' sperren!' : ' entsperrt!'))(error);
        });
    }

    public didTapDeleteLicense(license: SPHLicense) {
        this.licenseManagerService.deleteLicense(license.id, this.user.jwt).subscribe( (lcs) => {
            setTimeout( () => { this.loadLicenses(); }, 500);
            const toast = this.toastController.create({message: 'Lizenz gelöscht', duration: 3000});
            toast.present();
        }, this.licenseManagerService.handleHttpError('Fehler beim Löschen der Lizenz'));
    }

    public bulkSelection(select: boolean) {
        if (select) {
            this.licenses.forEach( (l) => {
                this.selectedLicenses.add(l);
            });
        } else {
            this.selectedLicenses.clear();
        }
    }

    public getPermissionsString(license: SPHLicense): string {
        if (license.applications.filter( (obj) => obj.name === 'eproject').length > 0) {
            return  (license.onlyassigned ? '' : 'Alle Projekte\n') + (license.extrainfos ? 'Zusatzinformationen\n' : '') + (license.loadprojectfiles ? 'Projektdateien anzeigen' : '');
        } else {
            return '';
        }
    }

    public didTapBulkActionButton(event) {
        let actions: Array<{ title: string, userdata: any }>;

        if (this.user.isUniAdmin) {
            actions = [
                {title: 'Neu senden', userdata: 'resend'},
                {title: 'Zuweisung löschen', userdata: 'reset'},
                {title: 'Sperren', userdata: 'lock'},
                {title: 'Entsperren', userdata: 'unlock'},
                {title: 'Löschen', userdata: 'delete'},
            ];
        } else {
            actions = [
                {title: 'Neu senden', userdata: 'resend'},
                {title: 'Zuweisung löschen', userdata: 'reset'},
                {title: 'Sperren', userdata: 'lock'},
                {title: 'Entsperren', userdata: 'unlock'},
            ];
        }

        const selLicenses: SPHLicense[] = [];
        this.selectedLicenses.forEach( (license) => {
            selLicenses.push(license);
        } );

        const popover = this.popoverController.create(SimpleOptionPopoverComponent, { actions, title: 'Aktion wählen'  });
        popover.present({
            ev: event
          });
        popover.onDidDismiss( (data) => {
            if (data !== undefined && data !== null) {
                switch (data) {
                    case 'resend':
                    {
                        this.licenseManagerService.resendLicenses(selLicenses, this.company.id, this.user.jwt).subscribe( (results) => {
                            const toast = this.toastController.create({message: 'Lizenzen gesendet!', duration: 3000});
                            toast.present();
                            setTimeout( () => { this.loadLicenses(); }, 500);
                        }, this.licenseManagerService.handleHttpError('Fehler beim neu senden der Lizenzen!'));
                        break;
                    }
                    case 'reset':
                    {
                        const modal = this.modalController.create(ResetLicenseComponent, { user: this.user, licenses: selLicenses, applications : this.availableApplications }, {enableBackdropDismiss: false});
                        modal.present();
                        modal.onDidDismiss(() => {
                          this.loadLicenses();
                        });
                        break;
                    }
                    case 'lock':
                    {
                        const observables = selLicenses.map( (license) => {
                            license.locked = true;
                            return this.licenseManagerService.patchLicense(license.id, license, this.user.jwt);
                        });
                        Observable.forkJoin(observables).subscribe( (results) => {
                            const toast = this.toastController.create({message: results.length +  (results.length > 1 ? ' Lizenzen' : ' Lizenzen') + ' gesperrt', duration: 3000});
                            toast.present();
                            setTimeout( () => { this.loadLicenses(); }, 500);
                        }, (error) => {
                            setTimeout( () => { this.loadLicenses(); }, 500);
                            this.licenseManagerService.handleHttpError('Fehler beim Sperren')(error);
                        });
                        break;
                    }
                    case 'unlock':
                    {
                        const observables = selLicenses.map( (license) => {
                            license.locked = false;
                            return this.licenseManagerService.patchLicense(license.id, license, this.user.jwt);
                        });
                        Observable.forkJoin(observables).subscribe( (results) => {
                            const toast = this.toastController.create({message: results.length +  (results.length > 1 ? ' Lizenzen' : ' Lizenzen') + ' entsperrt', duration: 3000});
                            toast.present();
                            setTimeout( () => { this.loadLicenses(); }, 500);
                        }, (error) => {
                            setTimeout( () => { this.loadLicenses(); }, 500);
                            this.licenseManagerService.handleHttpError('Fehler beim Entsperren')(error);
                        });
                        break;
                    }
                    case 'delete':
                    {
                        const observables = selLicenses.map( (license) => {
                            return this.licenseManagerService.deleteLicense(license.id, this.user.jwt);
                        });
                        Observable.forkJoin(observables).subscribe( (results) => {
                            const toast = this.toastController.create({message: results.length +  (results.length > 1 ? ' Lizenzen' : ' Lizenzen') + ' gelöscht', duration: 3000});
                            toast.present();
                            setTimeout( () => { this.loadLicenses(); }, 500);
                        }, this.licenseManagerService.handleHttpError('Fehler beim Löschen'));
                        break;
                    }

                }

            }

            this.bulkSelection(false);
        });
    }

    private loadLicenses() {
        this.shouldReloadLicences.emit();
    }

    private loadApplications() {
        if (this.user !== undefined) {
            this.licenseManagerService.getApplications(this.user.jwt).subscribe((applications) => {
                this.availableApplications = applications;
            }, this.licenseManagerService.handleHttpError('Fehler bei Lizenzen-Abruf'));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/licensesComponent/licenses.component.ts